<!-- @Version: 1.0.4 --> 
<div class="button button-toggle-container" data-testid="linkContainer" >
   <a data-testid="linkLink" cdkMonitorElementFocus (click)="onKeyboardEnter()" (keyup.enter)="onKeyboardEnter()" (keydown.enter)="onKeyboardEnter()" target="_blank" rel="noopener noreferrer" [attr.href]="fieldItem.attribute_4">
      <mat-button-toggle-group class="set-color-unchecked" [formControl]="fcLinkButton" data-testid="toggle-group">
         <mat-button-toggle [attr.color]="fcLinkButton.dirty ?  colorSuccess : colorDefault" data-testid="click-button-link" >
            @if (iconDefault && iconSuccess) {
               <mat-icon data-testid="linkIcon" [attr.color]="'white'">{{fcLinkButton.dirty ? iconSuccess : iconDefault}}</mat-icon>
            }{{fieldItem.attribute_6}}
         </mat-button-toggle>
      </mat-button-toggle-group>
   </a>
   @if (fieldItem.required && fcLinkButton.pristine) {
      <mat-hint data-testid="required-hint">{{TRANSLATE_PATH.REQUIRED | translateDesign}}</mat-hint>
   }
   @else if (fcLinkButton.dirty) {
      <mat-hint data-testid="done-message">{{TRANSLATE_PATH.LINK_DONE | translateDesign}}</mat-hint>
   }
   @else {
      <mat-hint data-testid="hint-placeholder" class="visibility">&nbsp;</mat-hint>
   }
</div>